import { render } from "./LocationEdit.html?vue&type=template&id=cb2fe810&scoped=true&ts=true"
import script from "./LocationEdit.ts?vue&type=script&lang=ts"
export * from "./LocationEdit.ts?vue&type=script&lang=ts"

import "./LocationEdit.css?vue&type=style&index=0&id=cb2fe810&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2fe810"]])

export default __exports__